module.exports = __webpack_public_path__ + "img/Ford-Mustang-2.41e3b74d.png";